import React, { useState } from 'react';
import './RejectionDialog.css';

interface RejectionDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
  title?: string;
  message?: string;
}

const RejectionDialog: React.FC<RejectionDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Reject Q&A Candidate',
  message = 'Please provide a reason for rejection:'
}) => {
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');

  if (!isOpen) return null;

  const handleConfirm = () => {
    if (!reason.trim()) {
      setError('Please provide a reason for rejection');
      return;
    }
    onConfirm(reason.trim());
    setReason('');
    setError('');
  };

  const handleClose = () => {
    setReason('');
    setError('');
    onClose();
  };

  return (
    <div className="rejection-dialog-overlay" onClick={handleClose}>
      <div className="rejection-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="rejection-dialog-header">
          <h3>{title}</h3>
        </div>
        
        <div className="rejection-dialog-content">
          <div className="rejection-dialog-message">
            <p>{message}</p>
          </div>

          <div className="rejection-dialog-form">
            <label htmlFor="rejection-reason">Reason for rejection:</label>
            <textarea
              id="rejection-reason"
              value={reason}
              onChange={(e) => {
                setReason(e.target.value);
                setError('');
              }}
              rows={4}
              className="rejection-reason-textarea"
              placeholder="Enter reason for rejection..."
              autoFocus
            />
            {error && <div className="rejection-error">{error}</div>}
          </div>

          <div className="rejection-dialog-actions">
            <button
              className="rejection-cancel-btn"
              onClick={handleClose}
            >
              Cancel
            </button>
            <button
              className="rejection-confirm-btn"
              onClick={handleConfirm}
            >
              Confirm Rejection
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RejectionDialog;

